module.exports = __webpack_public_path__ + "img/flag-ethiopia.26c57c9e.png";